// @noflow
import './styles.css';

import { DeviceSelector } from '../';
import ImmutablePropTypes from 'react-immutable-proptypes';
import PropTypes from 'prop-types';
import * as React from 'react';

const propTypes = {
    action: PropTypes.string,
    currentIndex: PropTypes.number,
    deviceType: PropTypes.string.isRequired,
    handleSelection: PropTypes.func.isRequired,
    isDeviceActiveState: PropTypes.bool,
    list: ImmutablePropTypes.list.isRequired
};

const RecipeWhen = ({ action, currentIndex, deviceType, handleSelection, isDeviceActiveState, list }) => {
    return (
        <div className="recipes-when">
            <DeviceSelector
                action={action}
                currentIndex={currentIndex}
                deviceType={deviceType}
                handleSelection={handleSelection}
                isDeviceActiveState={isDeviceActiveState}
                list={list}
            />
        </div>
    );
};
RecipeWhen.propTypes = propTypes;

export default RecipeWhen;



// WEBPACK FOOTER //
// ./src/components/widgets/recipes/when/index.js